<div class="ot-modal ot-modal--is-active" id="otsc-about-dialog">
  <div class="ot-modal__content">
    <div class="ot-modal__body" (keyup)="onKey($event)">
      <div class="ot-aboutbox ot-aboutbox--has-tabs">
        <div class="ot-aboutbox__head">
          <div class="ot-brand" id="about-title">
            <div id="otsc-about-dialog_close_btn" tabindex="0" class="ot-close-icon ot-aboutbox__close"
              (click)="close()" (keyup.enter)="close()">
            </div>
            <a class="ot-logo" href="/">
              <img i18n-alt alt="System Center Manager" src="./assets/icons/logo-dark.svg" title="OpenText">
            </a>
            <div class="ot-aboutbox__product">
              System Center Manager
            </div>
            <div class="ot-aboutbox__version" i18n>
              Version {{productVersion}}
            </div>
          </div>
        </div>
        <div class="ot-panel__header" style="overflow: hidden;">
          <app-tabs [identifier]="'about-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs"
            [color]="TabColor.PRIMARY" [selectedIndex]="activeTab"></app-tabs>
        </div>
        @if (activeTab == AboutPageTab.ABOUT) {
        <div class="ot-aboutbox__content">
          <ng-scrollbar>
            <p i18n>
              Copyright © 2026 Open Text. All rights reserved. OpenText is a trademark or registered trademark of Open
              Text. The list of trademarks is not exhaustive of other trademarks, registered trademarks, product names,
              company names, brands and service names mentioned herein are property of Open Text or other respective
              owners.
            </p>
            <p i18n>
              One or more patents may cover this product. For more information, please visit, <a
                href="https://www.opentext.com/patents" target="_blank">https://www.opentext.com/patents</a>
            </p>
            <div class="ot-aboutbox__label" i18n>
              Disclaimer
            </div>
            <p i18n>
              No Warranties and Limitation of Liability. Every effort has been made to ensure the accuracy of the
              features and techniques presented in this publication. However, Open Text Corporation and its affiliates
              accept no responsibility and offer no warranty whether expressed or implied, for the accuracy of this
              publication.
            </p>
            <div class="ot-aboutbox__label" i18n>
              Warning
            </div>
            <p i18n>
              This software is protected by copyright law and international treaties. Unauthorized reproduction or
              distribution of this program, or any portion of it, may result in severe civil and criminal penalties, and
              will be prosecuted to the maximum extent possible under the law.
            </p>
          </ng-scrollbar>
        </div>
        }
        @if (activeTab == AboutPageTab.CONTACT) {
        <div class="ot-aboutbox__content">
          <p i18n>
            OpenText Website <br>
            <a href="https://www.opentext.com" target="_blank">https://www.opentext.com</a>
          </p>
          <p i18n>
            OpenText My Support <br>
            <a href="https://support.opentext.com/" target="_blank">https://support.opentext.com/</a>
          </p>
        </div>
        }
      </div>
    </div>
  </div>
</div>